import { render, staticRenderFns } from "./svg-file-icon.vue?vue&type=template&id=44f37bde&"
var script = {}


/* normalize component */
import normalizer from "!../../../../create-website/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports